import classNames from "classnames";
import { type FC } from "react";
import { PersonRecord } from "@/common/PersonRecord";
import { MobileActionsMenu } from "@/common/MobileActionsMenu";
import { useAppDispatch } from "@/services/store";
import { mobileNoteEditorSliceActions } from "@/common/NotesTable/model/mobile-note-editor-slice";
import { handleFullName } from "@/shared/utils/handle-contacts-null";
import { useRuntimeImage } from "@/entities/runtime-image";
import type { Person } from "@/services/api/entities/person";
import type { NoteStatus, NoteTypes } from "@/services/api/entities/note/types";
import type { AvatarSize } from "../../../shared/Components/AppAvatar/types/index";
import type { Note } from "@/services/api";
import type { MaybeType } from "@/shared/types";
import type { NotesTableItem } from "@/features/NotesManager/model";
import { getStatusText } from "../helpers";
import styles from "../styles.module.scss";
import { CommitmentFlag } from "./CommitmentFlag";
import { NoteTypeTag } from "./NoteTypeTag";

interface Props {
  id: string;
  deleteNote?: (ids: string[]) => void;
  person: MaybeType<Person>;
  isOptions?: boolean;
  isEdit?: boolean;
  date: string;
  isShowFlag?: boolean;
  flag: Note["direction"];
  avatarSize: AvatarSize;
  noteType: NoteTypes;
  status: NoteStatus;
  noteItem?: NotesTableItem;
  selected?: boolean;
  statusColor: string;
}

export const Header: FC<Props> = ({
  person,
  isOptions = false,
  isEdit,
  avatarSize,
  isShowFlag = true,
  flag,
  noteType,
  status,
  noteItem,
  selected,
  statusColor,
}) => {
  const dispatch = useAppDispatch();
  const { getRuntimeImageURL } = useRuntimeImage();

  const statusText = getStatusText(status);

  return (
    <div className={styles.header}>
      <div className={styles["header-top"]}>
        <NoteTypeTag noteType={noteType} status={status} />
        <div className={styles["header-end"]}>
          <div className={classNames(styles[statusText.color], styles[statusColor])}>
            {statusText?.dueText}
          </div>
          {isOptions && !isEdit && (
            <MobileActionsMenu
              className={styles["header-menu"]}
              rootClassName={styles["header-menu-dropdown"]}
              onEdit={() => {
                dispatch(mobileNoteEditorSliceActions.setEdit(true));
                noteItem && dispatch(mobileNoteEditorSliceActions.setNote(noteItem));
              }}
            />
          )}
        </div>
      </div>
      <div className={styles["header-person"]}>
        <PersonRecord
          avatar={getRuntimeImageURL({ fileId: person?.avatarFile?.fileId ?? "" })}
          group={person?.group ?? ""}
          name={handleFullName(person?.firstName, person?.lastName, person?.middleName)}
          title={person?.title ?? ""}
          avatarSize={avatarSize}
          selected={selected}
        />

        <CommitmentFlag isShowFlag={isShowFlag} flag={flag} />
      </div>
    </div>
  );
};
